var XPortal = XPortal || {};
XPortal.CustomLogic = XPortal.CustomLogic || {};
XPortal.CustomLogic.NotificationsLogic = (function () {
    var self = { EmptyGuid: "00000000-0000-0000-0000-000000000000", EntityTypeMetadata: [] };
    self.Init = function (container) {
        XPortal.Main.customThemes();
        container = container ? container : $(XPortal.Main.DetialFormSelector);
        let $valueControl = container.find("[data-metadata-fieldname='RelatedEntityAlias']");
        if ($valueControl.length < 1) return;

        $("[data-metadata-fieldname=RelatedListId]").attr("readonly", "readonly");
        $("[data-metadata-fieldname=RelatedPageId]").attr("readonly", "readonly");
        $("[data-metadata-fieldname=RelatedPageUrl]").attr("readonly", "readonly");

        const modelName = XPortal.Store.getModelName(container[0].id);
        const model = XPortal.Store.GetModelByName(modelName).model;
        
        self.SubscribeForChanges(container, modelName);

        XPortal.EntityFilterPicker.Call({
            element: $valueControl, container: container, valueControl: $valueControl,
            data: JSON.stringify({ NodeId: model.NodeId }),
            url: $valueControl.attr("data-entityTypeMetadata-src")
        }, function bindMetadata(data, result) {
            if (console && result.Errors && result.Errors.length > 0) {
                console.log(result.Errors[0]);
            }
            if (!result.ProcessedResult) {
                return;
            }
            self.EntityTypeMetadata = result.ProcessedResult.Items ||[];

            if (self.CurrentEntityType)
                container.find("[data-metadata-fieldname='ColumnMetaData']").val(JSON.stringify(self.CurrentEntityType.ColumnsMetaData));
            else {
                const dataItemlistid =  XPortal.Template.GetObjPropValueByName(XPortal.Store.GetModelByName(modelName).entity, "relatedlistid")
                self.CurrentEntityType = dataItemlistid ? self.EntityTypeMetadata.find(en => en.ListId == dataItemlistid) : self.CurrentEntityType;
            }                
            XPortal.EntityFilterPicker.Call({
                url: $valueControl.attr("data-templates-src"),
                container: container, valueControl: $valueControl, data: JSON.stringify({
                    NodeId: model.NodeId,
                    RelatedPageId: self.CurrentEntityType != null ? self.CurrentEntityType.ListId : ""
                })
            }, function bindMetadata(data, result) {
                XPortal.NotifyTemplateEditor.UpdateTemplates(result);
                RefreshSelection($valueControl);
            });
        });

        $valueControl.on("change", function relatedEntityAliasChange(e) {
            let kendoCombo = $(e.target).data("kendoComboBox"), dataItem = null;
            if (kendoCombo) {
                dataItem = kendoCombo.dataSource._view[kendoCombo.selectedIndex];
                if (dataItem) self.CurrentEntityType = self.EntityTypeMetadata.find(en => en.ListId == dataItem.listid);
                self.SetTemplates({
                    url: $valueControl.attr("data-templates-src"),
                    container: container,
                    valueControl: $valueControl,
                    noTemplateText: $valueControl.attr("data-notification-notemplate"),
                    headerText: $valueControl.attr("data-modal-title"),
                    data: JSON.stringify({
                        NodeId: model.NodeId,
                        RelatedPageId: self.CurrentEntityType ? self.CurrentEntityType.ListId : null
                    })
                });
                XPortal.Store.DispatchFieldEditorEvent($valueControl, dataItem.value, modelName);
                $valueControl.attr("data-value", dataItem.value);
            }
            if (!self.CurrentEntityType) {
                XPortal.Modal.alert({
                    headerText: $valueControl.attr("data-modal-title"),
                    alertText: $valueControl.attr("data-notification-nosetting") + e.target.value
                });
                return;
            }

            XPortal.Store.DispatchNoAutoSave(modelName, "relatedpageid", self.CurrentEntityType.DetailInfo.details.nodeid
                ? self.CurrentEntityType.DetailInfo.details.nodeid
                : 0);

            XPortal.Store.DispatchNoAutoSave(modelName, "RelatedListId", self.CurrentEntityType.ListId);
            XPortal.Store.DispatchNoAutoSave(modelName, "RelatedPageUrl", self.CurrentEntityType.DetailInfo.details.url
                ? self.CurrentEntityType.DetailInfo.details.url
                : self.CurrentEntityType.DetailInfo.details.parentInfo);

            if ($valueControl.data().metadataFieldname == 'RelatedEntityAlias' && dataItem)
                XPortal.Store.DispatchNoAutoSave(modelName, "NotificationTitle", dataItem.title ? dataItem.title : '');

            XPortal.Store.AppStore.dispatch({
                type: XPortal.Redusers.ACTIONS.EDIT_FIELD,
                field: { field: "columnmetadata", data: JSON.stringify(self.CurrentEntityType.ColumnsMetaData) },
                model: modelName
            });
            XPortal.Store.AppStore.dispatch({
                type: XPortal.Redusers.ACTIONS.EDIT_FIELD,
                field: { field: "conditions", data: "" },
                model: modelName
            });
            XPortal.Store.DispatchNoAutoSave(modelName, "ColumnMetaData", JSON.stringify(self.CurrentEntityType.ColumnsMetaData));
            XPortal.Store.DispatchNoAutoSave(modelName, "conditions", "");
            XPortal.EntityFilterPicker.Init({ selectAllFields: true });
            XPortal.Store.DispatchNoAutoSave(modelName, "relatedentityuniqueid", XPortal.CustomLogic.NotificationsLogic.EmptyGuid);
            EnsureIsGroupNotification(modelName);
            XPortal.Store.DispatchByName(modelName, "relatedentityallkeys", "");
        });

        $valueControl.on("before-save", function (e) {
            e.preventDefault();
            if (XPortal.CustomLogic.NotificationsLogic.CurrentEntityType) {
                XPortal.Store.DispatchNoAutoSave(modelName, "columnmetadata", JSON.stringify(XPortal.CustomLogic.NotificationsLogic.CurrentEntityType.ColumnsMetaData));
            }
            setTimeout(function () {
                if (e.ondone) e.ondone(e);
            }, 1);
        });

        let $groupNamesControl = container.find("[data-metadata-fieldname='NotifyGroupNames']");
        $groupNamesControl.on("change", function (e) {
            setTimeout(function () {
                EnsureIsGroupNotification(modelName);
            }, 1);
        });
    };
    self.SetTemplates = function (options) {
        var modelName = XPortal.Store.getModelName(options.container[0].id);
        XPortal.EntityFilterPicker.Call(options, function bindMetadata(data, result) {
            const ts = result.Templates || {};
            self.DispatchEvents(modelName, ts.notify, ts.mail);
            XPortal.NotifyTemplateEditor.UpdateTemplates(result);
        });
    };
    self.AdjustDetailsEditorFields = function (options) {
        var notificationTypeValue;
        if (!options.modelName) return;
        var modelEntity = (XPortal.Store.GetModelByName(options.modelName) || {}).entity || {};
        if (options.filters && options.filters.length > 0)
            notificationTypeValue = options.filters.some(f => f.field != "___group___" && f.IsPeriodic) ? "periodic" : "conditional";
        else
            notificationTypeValue = modelEntity.relatedentityuniqueid === XPortal.CustomLogic.NotificationsLogic.EmptyGuid && modelEntity.relatedentityallkeys === "" ? "allrecords" : "direct";
        XPortal.Store.DispatchByName(options.modelName, "NotificationType", notificationTypeValue);
    };
    self.SubscribeForChanges = function (xcontainer, modelName) {
        self.SubscribeElement(xcontainer, modelName, "[data-metadata-fieldname='RelatedListId']", "RelatedListId value changed: ");
        self.SubscribeElement(xcontainer, modelName, "[data-metadata-fieldname='NotificationTemplateId']", "NotificationTemplateId value changed");
        self.SubscribeElement(xcontainer, modelName, "[data-metadata-fieldname='NotificationMailTemplateId']", "NotificationMailTemplateId value changed");
        self.SubscribeElement(xcontainer, modelName, "[data-metadata-fieldname='RelatedPageUrl']", "RelatedPageUrl value changed: ");
        self.SubscribeElement(xcontainer, modelName, "[data-metadata-fieldname='RelatedEntityAlias']", "RelatedEntityAlias value changed: ");
        self.SubscribeElement(xcontainer, modelName, "[data-metadata-fieldname='NotificationType']", "NotificationType value changed: ");
        self.SubscribeElement(xcontainer, modelName, "input[data-metadata-fieldname=RelatedEntityUniqueId]", "RelatedEntityUniqueId value changed: ");
        self.SubscribeElement(xcontainer, modelName, "input[data-metadata-fieldname=RelatedEntityAllKeys]", "RelatedEntityAllKeys value changed: ");
    };
    self.SubscribeElement = function (xcontainer, modelName, elSelector, chgMsg) {
        var elAll = xcontainer && xcontainer.length ? xcontainer.find(elSelector) : $(elSelector);
        if (!(elAll && elAll.length)) return;

        const sttgs = XPortal.Main.GetSettingsFor(elAll);
        XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: elAll },
            (value) => {
                elAll.each(function (elIndex, eli) {
                    const el = $(eli);
                    if (el.is(":input")) el.val(value);
                    else el.text(value);
                });

            }
        );
    };
    self.DispatchEvents = function (modelName, notification, mail) {
        XPortal.Store.DispatchNoAutoSave(modelName, "Title", notification ? notification.Subject : "");
        XPortal.Store.DispatchNoAutoSave(modelName, "Description", notification ? notification.Message : "");
        XPortal.Store.DispatchNoAutoSave(modelName, "MailSubject", mail ? mail.Subject : "");
        XPortal.Store.DispatchByName(modelName, "MailBody", mail ? mail.Message : "");
    };

    function RefreshSelection($valueControl) {
        var relatedList = $("[data-metadata-fieldname=RelatedListId]").val();
        if (relatedList && relatedList > 0 && self.EntityTypeMetadata.find(en => en.ListId == relatedList)) {
            let items = $valueControl.data("kendoComboBox").ul.children();
            if (items != null && items.length)
                items.each(function () { $(this).removeClass("k-state-selected"); });
            self.CurrentEntityType = self.EntityTypeMetadata.find(en => en.ListId == relatedList);
            $valueControl.data("kendoComboBox").value([]);
            $valueControl.data("kendoComboBox").select(self.EntityTypeMetadata.indexOf(self.CurrentEntityType));
        }
        else
            self.CurrentEntityType = self.EntityTypeMetadata.find(en => en.EntityType === $valueControl.val());
    };

    function EnsureIsGroupNotification(modelName) {
        let entity = (XPortal.Store.GetModelByName(modelName) || {}).entity || {};
        let grNames = XPortal.Template.GetObjPropValueByName(entity, "NotifyGroupNames");
        let isGroupNotificationType = grNames && grNames.length ? 1 : 0;
        XPortal.Store.DispatchNoAutoSave(modelName, "IsGroupNotificationType", isGroupNotificationType);
    };
    return self;
}());


